import { render, staticRenderFns } from "./ResearchFile.vue?vue&type=template&id=58c65150&scoped=true&"
import script from "./ResearchFile.vue?vue&type=script&lang=js&"
export * from "./ResearchFile.vue?vue&type=script&lang=js&"
import style0 from "./ResearchFile.vue?vue&type=style&index=0&id=58c65150&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c65150",
  null
  
)

export default component.exports